/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./EmailSend.vue?vue&type=template&id=0fc81e1a&scoped=true&"
import script from "./EmailSend.vue?vue&type=script&lang=js&"
export * from "./EmailSend.vue?vue&type=script&lang=js&"
import style0 from "./EmailSend.vue?vue&type=style&index=0&id=0fc81e1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc81e1a",
  null
  
)

export default component.exports